import config from 'config';
import { authHeader } from '@mobile/services/user';
import axios from '@mobile/util/axios';

export default {
    upgrade,
};

async function upgrade(form) {
    const request = {
        headers: authHeader(),
        data: form,
        method: 'post',
        url: `${config.apiUrl}/${config.apiVersion}/upgrade`,
    };

    const upgradeRequest = await axios(request);
    if (upgradeRequest && upgradeRequest.status == 200) {
        return upgradeRequest.data;
    }
    return undefined;
}
